/* eslint-disable @typescript-eslint/naming-convention */
import React from 'react';
import { AILoadingPlaceholder } from '../../../../../../ui/organisms/AILoadingPlaceholder/AILoadingPlaceholder';
import { Text } from '../../../../../../ui/atoms/Text/Text';
import { Button } from '../../../../../../ui/atoms/Button/Button';
import { SSE_MAX_RETRIES } from '../../../../../../hooks/useQuerySubscription';
import './ReconnectionBannerStyles.scss';
const BASE_CLASS = 'ai-reconnection-banner';
export function ReconnectionBanner({ connectionState, reconnectAttempts, onReconnect, wasAuthRefresh = false }) {
    // Defense-in-depth: only render the "Reconnecting…" banner once an actual
    // retry has been counted. Without the `reconnectAttempts > 0` guard the
    // banner could display "Attempt 0 of 20" if any future state-machine
    // regression sets `connectionState='reconnecting'` before `onerror` has
    // incremented attempts (see useQuerySubscription).
    if (connectionState === 'reconnecting' && reconnectAttempts > 0) {
        const label = wasAuthRefresh ? 'Refreshing your session\u2026' : 'Reconnecting\u2026';
        return (React.createElement("div", { className: BASE_CLASS, role: "alert" },
            React.createElement(AILoadingPlaceholder, { label: label, detail: `Attempt ${reconnectAttempts} of ${SSE_MAX_RETRIES}` })));
    }
    if (connectionState === 'error') {
        return (React.createElement("div", { className: `${BASE_CLASS} ${BASE_CLASS}--error`, role: "alert" },
            React.createElement("i", { className: "fa-light fa-triangle-exclamation", "aria-hidden": "true" }),
            React.createElement(Text, { variant: "xx-small", className: `${BASE_CLASS}__message` }, "Connection lost."),
            onReconnect && (React.createElement(Button, { variant: "secondary", className: `${BASE_CLASS}__reconnect-btn`, onClick: onReconnect }, "Try reconnecting"))));
    }
    return null;
}
